import { LevelOfEducationEntity } from '../entities/level-of-education-entity';

export default class State {
  items: Array<LevelOfEducationEntity> = [];

  loaded = false;
}
